import React, { Component, Fragment } from 'react';
import {
  Sidebar,
  Badge, Grid,
} from 'framework-ui-components';
import DocumentIcon from 'framework-ui-components/Components/Icons/DocumentIcon';
import BusinessContactIcon from 'framework-ui-components/Components/Icons/BusinessContactIcon';
import BusinessContactsIcon from 'framework-ui-components/Components/Icons/BusinessContactsIcon';
import CloneIcon from 'framework-ui-components/Components/Icons/CloneIcon';
import { Route, Redirect, Switch } from 'react-router-dom';

import FwPlugins from 'framework-plugins';
import { connect } from 'react-redux';
import Servizi from 'enums/Servizi';
import { PageWrapper } from 'dashboard';
import ErroreIcon from 'framework-ui-components/Components/Icons/ErroreIcon';
import Icon730 from '../../Components/Icons/7304Icon';
import SetteTrenta from './SetteTrenta';
import BarraQuattro from './Barra4';
import Sostituto from './Sostituto';
import ElencoSostituti from './ElencoSostituti';
import RichiesteEnti from '../RichiesteEnti';
import checkServizio from '../../helpers/checkServizio';

class SidebarSetteTrenta extends Component {
  constructor(props) {
    super(props);
    this.menuSidebarRef = React.createRef();
  }


  componentDidMount() {
    this.menuSidebarRef.current.addEventListener('click', this.onClickCheck, true);
  }

  componentWillUnmount() {
    this.menuSidebarRef.current.removeEventListener('click', this.onClickCheck, true);
  }

  onClickCheck = (event) => {
    FwPlugins.clickOutEventFilter(event);
  }

  render() {
    const {
      children,
      annoSelezionato,
      accessoNonConsentito,
    } = this.props;

    return (
      <Sidebar>
        <Sidebar.Menu>
          <span ref={this.menuSidebarRef}>
            <Sidebar.Item icon={<DocumentIcon />} link="/SetteTrenta/Elenco">Dichiarazioni 730</Sidebar.Item>
            <Sidebar.Item icon={<Icon730 />} link="/SetteTrenta/Barra4">730/4</Sidebar.Item>
            <Sidebar.Item icon={<BusinessContactIcon />} link="/SetteTrenta/ElencoSostituti">Sostituti</Sidebar.Item>
            <Sidebar.Item icon={<CloneIcon />} link="/SetteTrenta/RichiesteEnti">Richieste Enti</Sidebar.Item>
          </span>
        </Sidebar.Menu>
        <Sidebar.Body>

          {accessoNonConsentito

            ? (
              <PageWrapper
                helmetTitle="730"
                pageTitle={(
                  <div className="w-300">
                    <div className="w-140 floatLeft mr-8">
                      <span>730 </span>
                    </div>
                  </div>
                )}
              >
                <Grid fluid className="pl-0 pr-0">
                  <Grid.Row>
                    <Grid.Col md="12">
                      <div className="errorBoundary">
                        <div className="errorBoundary__content">
                          <Badge alarm><ErroreIcon /></Badge>
                          <h2>Il servizio 730 non è attivo</h2>
                        </div>
                      </div>
                    </Grid.Col>
                  </Grid.Row>
                </Grid>
              </PageWrapper>
            )
            : (
              <Switch>
                <Route exact path="/SetteTrenta/Elenco" component={SetteTrenta} />
                <Route exact path="/SetteTrenta/Barra4" component={BarraQuattro} />
                <Route path="/SetteTrenta/RichiesteEnti/:detail?" component={RichiesteEnti} />
                <Route exact path="/SetteTrenta/ElencoSostituti" component={ElencoSostituti} />
                <Route exact path="/SetteTrenta/Sostituto/:cfSostituto/:nomeSostituto" component={Sostituto} />
                <Redirect exact from="/SetteTrenta" to="/SetteTrenta/Elenco"/>
                {children}
              </Switch>
            )}
        </Sidebar.Body>
      </Sidebar>
    );
  }
}

const mapStoreToProps = store => ({
  annoSelezionato: store.dichiarativi.annoSelezionato,
});

export default checkServizio(Servizi['7OL'])(connect(mapStoreToProps, null)(SidebarSetteTrenta));
